export type IProcessingSteps = "CHECK_ORDER" | "SUBSCRIBE";

export const ServiceProcessingEventStep: {
  [key in IProcessingSteps]: string;
} = {
  CHECK_ORDER: "checkout_basket",
  SUBSCRIBE: "subscription_advantages",
};
